import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import DOMPurify from "dompurify";
import "./slider.css";

export const sanitizeImageUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  const isSafeProtocol = /^(https?:\/\/|\/|\.\/)/i.test(trimmed);
  const isDangerous = /^(javascript|data|vbscript):/i.test(trimmed);

  if (isSafeProtocol && !isDangerous) {
    return DOMPurify.sanitize(trimmed);
  }
  return "";
};

const sanitizeLinkUrl = (url) => {
  if (!url || typeof url !== "string") return "#";
  const trimmed = url.trim();
  const isSafeProtocol = /^(https?:\/\/|\/|\.\/|#)/i.test(trimmed);
  const isDangerous = /^(javascript|data|vbscript):/i.test(trimmed);

  if (isSafeProtocol && !isDangerous) {
    return DOMPurify.sanitize(trimmed);
  }
  return "#";
};

function Slider(props) {
  const [activeButton, setActiveButton] = useState(
    localStorage.getItem("lng") || "es"
  );

  const renderSlider = () => {
    return (
      <div className="slideBorder">
        <div className="carouselContainer">
          <Carousel interval={5000} controls={true} indicators={true}>
            {props.banners &&
              props.banners
                .sort((a, b) => a.posicion - b.posicion)
                .map((banner, index) => {
                  if (banner.landing !== "1" && banner.landing !== "3") {
                    return null;
                  }

                  // Sanitizar atributos antes del renderizado
                  const rawImage =
                    activeButton === "es" ? banner.image : banner.image_en;
                  const rawLink =
                    activeButton === "es" ? banner.link : banner.link_en;

                  const safeImage = sanitizeImageUrl(rawImage);
                  const safeLink = sanitizeLinkUrl(rawLink);
                  const hasLink = Boolean(banner.link || banner.link_en);

                  return (
                    <Carousel.Item key={banner.id}>
                      {hasLink ? (
                        <a href={safeLink} id={`bannerHome${index}`}>
                          <img src={safeImage} alt="Banner" />
                        </a>
                      ) : (
                        <img src={safeImage} alt="Banner" />
                      )}
                    </Carousel.Item>
                  );
                })}
          </Carousel>
        </div>
      </div>
    );
  };


  return <>{renderSlider()}</>;
}

export default Slider;
